import base from '../dr-base'
import drCalendar from './dr-calendar.vue'

const schema = {
  $Type: 'dr-calendar',
  name: 'Calendar',
  group: 'Common widgets',
  icon: 'calendar-day',
  ...base,
  properties: {
    ...base.properties,
    Events: {
      name: 'vuetifyWidgets.dr-calendar.events',
      type: 'string',
      component: 'dr-value-editor'
    },
    Type: {
      name: 'vuetifyWidgets.dr-calendar.calendarType',
      type: 'string',
      default: 'month',
      enum: [
        { value: 'month', text: 'vuetifyWidgets.dr-calendar.month' },
        { value: 'week', text: 'vuetifyWidgets.dr-calendar.week' },
        { value: 'day', text: 'vuetifyWidgets.dr-calendar.day' },
        { value: '4day', text: 'vuetifyWidgets.dr-calendar.4day' }
      ]
    }
  }
}

export default {
  schema,
  component: drCalendar
}